import {booleanValue,type Sample} from './model';
export type RouteLineConfig={version:1;allOf:string[];noneOf:string[];routes:Array<{running:string;origin:string;destination:string;noneOf:string[];matches:Array<[number,number]>}>};
export function routeLineConfig(raw:unknown):RouteLineConfig|null {
  const c=raw as RouteLineConfig;
  const refs=(v:unknown):v is string[]=>Array.isArray(v)&&v.every(x=>typeof x==='string'&&x.length>0);
  if(!c||c.version!==1||!refs(c.allOf)||!c.allOf.length||!refs(c.noneOf)||!Array.isArray(c.routes)||!c.routes.length||c.routes.length>2)return null;
  for(const r of c.routes)if(!r||![r.running,r.origin,r.destination].every(x=>typeof x==='string'&&x.length>0)||!refs(r.noneOf)||!Array.isArray(r.matches)||!r.matches.length||!r.matches.every(p=>Array.isArray(p)&&p.length===2&&p.every(x=>Number.isInteger(x)&&x>=0&&x<=65535)))return null;
  return c;
}
/** A selected target is insufficient: route status AND observed equipment/gate feedback must agree.
 * Quality is supplied by the acquisition clock; unknown/stale never become green.
 * Each route is an independent OR branch, so an unavailable idle zone cannot hide a proven live one.
 */
export function routeLineState(raw:unknown,effects:Record<string,Sample>):'active'|'idle'|'unknown' {
  const c=routeLineConfig(raw);if(!c)return 'unknown';
  const bool=(id:string)=>booleanValue(effects[id]??{});
  const word=(id:string)=>{const s=effects[id],v=s?.last_value??s?.value;return s?.quality==='good'&&typeof v==='number'&&Number.isInteger(v)&&v>=0&&v<=65535?v:null;};
  const positives=c.allOf.map(bool),negatives=c.noneOf.map(bool);
  if(positives.includes(false)||negatives.includes(true))return 'idle';
  if(positives.includes(null)||negatives.includes(null))return 'unknown';
  let unknown=false;
  for(const r of c.routes){
    const running=bool(r.running),blocked=r.noneOf.map(bool);
    if(running===false||blocked.includes(true))continue;
    if(running===null||blocked.includes(null)){unknown=true;continue;}
    const origin=word(r.origin),destination=word(r.destination);
    if(origin===null||destination===null){unknown=true;continue;}
    if(r.matches.some(([a,b])=>a===origin&&b===destination))return 'active';
  }
  return unknown?'unknown':'idle';
}
